import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import Soporte from "./pages/Soporte";
import { initGA, trackPageview } from "./lib/analytics";

// Inicializa GA una sola vez al cargar la app
initGA();

// Router listener que dispara pageview en cada cambio de ruta (SPA)
const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/soporte" element={<Soporte />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        richColors
        closeButton
        toastOptions={{
          style: { fontFamily: "Manrope, sans-serif" },
        }}
      />
    </div>
  );
}

export default App;
